import React, { createContext, useReducer, ReactNode, Dispatch } from 'react';
import Reducer, { Action, NicknameFieldState } from '../../reducers/regform-fields/nickname-field-reducer';

type NicknameFieldContextType = [NicknameFieldState, Dispatch<Action>];

const initialState: NicknameFieldState = {
	value: '',
	error: {
		message: '',
		show: false,
	},
	suggestions: [],
	valid: null,
};

export const NicknameFieldContext = createContext<NicknameFieldContextType>([initialState, () => null]);
interface NicknameFieldStoreProps {
	children: ReactNode;
}

const NicknameFieldStore: React.FC<NicknameFieldStoreProps> = ({ children }) => {
	const [state, dispatch] = useReducer(Reducer, initialState);

	return (
		<NicknameFieldContext.Provider value={[state, dispatch]}>
			{children}
		</NicknameFieldContext.Provider>
	);
};

export default NicknameFieldStore;
